module.exports = __webpack_public_path__ + "static/img/WarmPlate (6).4b09def1.png";